import { render, staticRenderFns } from "./general-pay-link-settings.vue?vue&type=template&id=4480b391"
import script from "./general-pay-link-settings.vue?vue&type=script&lang=js"
export * from "./general-pay-link-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports